import { render, staticRenderFns } from "./repeatList.vue?vue&type=template&id=3c2c7b8d"
import script from "./repeatList.vue?vue&type=script&lang=ts"
export * from "./repeatList.vue?vue&type=script&lang=ts"
import style0 from "./repeatList.vue?vue&type=style&index=0&id=3c2c7b8d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports